import { useToast } from "../hooks/useToast";
import styles from "./Toast.module.css";

const ICONS: Record<string, string> = {
  success: "✓",
  error: "✕",
  warning: "⚠",
  info: "ℹ",
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (!toasts.length) return null;

  return (
    <div className={styles.container} role="region" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className={`${styles.toast} ${styles[toast.type]}`}>
          <span className={styles.icon}>{ICONS[toast.type]}</span>
          <span className={styles.message}>
            {toast.message}
            {toast.type === "error" && (toast.count ?? 1) > 1
              ? ` (${toast.count} gleichartige Fehler)`
              : null}
          </span>
          <button
            className={styles.close}
            onClick={() => removeToast(toast.id)}
            aria-label="Schließen"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
